import type { KerningOverrides } from "./types";

const CANONICAL_INDEX = /^(0|[1-9]\d*)$/;

export const normalizeKerningOverrides = (
  raw: unknown
): KerningOverrides | undefined => {
  if (raw === null || raw === undefined) return undefined;
  if (typeof raw !== "object") return undefined;
  if (Array.isArray(raw)) return undefined;

  const out: KerningOverrides = {};
  let count = 0;

  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (!CANONICAL_INDEX.test(key)) continue;
    const idx = Number(key);
    if (!Number.isInteger(idx) || idx < 0) continue;
    if (typeof value !== "number" || !Number.isFinite(value)) continue;
    if (value === 0) continue;
    out[idx] = value;
    count++;
  }

  return count > 0 ? out : undefined;
};
